var React = require('react');

function IconTop (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M948.917 53.57v86.573H83.186V53.57h865.731zM516.051 183.43l432.866 420.01H696.989l.996 315.862H335.243V603.44H83.186l432.865-420.01z"}));
}

IconTop.displayName = "IconTop";

IconTop.defaultProps = {"viewBox":"15.167 -16.333 1000.636 1000.678"};

module.exports = IconTop;

IconTop.default = IconTop;
